import React from 'react'
import {
  StatusBullet,
  DNAText,
} from '@alucio/lux-ui'
import DNAPopover from 'src/components/DNA/Popover/DNAPopover'
import { DocumentORM } from 'src/types/types'

const DNADocumentStatusDot: React.FC<{ documentORM: DocumentORM }> = (props) => {
  const { documentORM } = props

  if (
    documentORM.model.status !== 'NOT_PUBLISHED' ||
    documentORM.meta.tenantFields.labelCompletion
  ) {
    return null;
  }

  return (
    <DNAPopover >
      <DNAPopover.Anchor>
        <StatusBullet status="warning" />
      </DNAPopover.Anchor>
      <DNAPopover.Content offset={2}>
        <DNAText
          numberOfLines={1}
          style={{ color: 'white' }}
        >
          A few more labels to go before publishing!
        </DNAText>
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export default DNADocumentStatusDot
